module.exports = __webpack_public_path__ + "public/images/otm-logo-white.390bfcb500068d50ce922d8bbb476dbb.svg";